window.jivo_onLoadCallback = function jivo_onLoadCallback() {
	if (window.loginRecente) {
		jivo_api.clearHistory()
	}
	jivo_api.setContactInfo({
		name: `${window.$sessao.getNome()} - ${window.$cliente.get('nome_pasta')}`
	})
}
